import { SortParams } from "@/types/types";

import { IFilterWithValues } from "../../List/components/FilterModal";
import { OrganizationRequestParams } from "../schema/contact-organization.types";

interface BuildOrganizationQueryParamsInput {
	page: number;
	limit: number;
	sortingInbox: SortParams;
	/** Debounced search term; an empty string means "no search". */
	query?: string;
	/** Advanced filter; sent JSON-encoded, and omitted entirely when empty. */
	filter?: IFilterWithValues;
	semanticSearchOrganizations?: string;
}

/**
 * Request params for the paginated organization endpoints (Companies / Competitors).
 * Empty search, filter and semantic-search values are left out rather than sent as
 * empty strings, so they do not become part of the RTK Query cache key.
 */
export const buildOrganizationQueryParams = ({
	page,
	limit,
	sortingInbox,
	query,
	filter,
	semanticSearchOrganizations,
}: BuildOrganizationQueryParamsInput): OrganizationRequestParams => ({
	page,
	limit,
	searchValue: query || undefined,
	sortBy: sortingInbox.sortBy,
	sortOrder: sortingInbox.sortOrder,
	...(filter && Object.keys(filter).length > 0 && { filter: JSON.stringify(filter) }),
	...(semanticSearchOrganizations && { semanticSearchOrganizations }),
});
